import { BulkDomainSearchSelectedTldListView } from '.'

export class BulkDomainSearchTldView {
  private selectedTldListView: BulkDomainSearchSelectedTldListView
  private tld: string

  constructor(
    el: HTMLElement,
    selectedTldListView: BulkDomainSearchSelectedTldListView
  ) {
    this.selectedTldListView = selectedTldListView
    const { tld } = el.dataset

    if (!tld) {
      throw new Error('BulkDomainSearchTldView: data-tld is null')
    }

    this.tld = tld

    el.addEventListener('click', this.onClick.bind(this))
  }

  private onClick = (e: Event): void => {
    e.preventDefault()
    this.selectedTldListView.appendTld(this.tld)
  }
}
